/**
 * An account an admin has still to decide on (migration 0012). Since 28
 * September 2026 the API opens every new account at once, so no one signing
 * up waits here; it remains for an account made before then that is still
 * marked as waiting, until an admin approves or declines it.
 *
 * Short on purpose. The person has done everything they can; the screen's job
 * is to say so, say how they will hear, and not look broken.
 */

import { Button } from "../ui";

export interface AwaitingProps {
  readonly email: string;
  readonly name: string | null;
  /** Ask the API again, for someone who was told they are approved. */
  readonly onCheck: () => void;
  readonly onSignOut: () => void;
}

export function Awaiting(props: AwaitingProps) {
  const first = props.name?.trim().split(/\s+/)[0];
  return (
    <div class="auth-step">
      <h1>{first ? `Thanks, ${first}` : "Thanks"}</h1>
      <p class="auth-lede">
        We will email <b>{props.email}</b> when your account is approved.
      </p>
      <div class="auth-actions">
        <Button variant="primary" block onClick={props.onCheck}>
          Check again
        </Button>
        <div class="auth-row">
          <Button variant="quiet" size="sm" onClick={props.onSignOut}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
